import { useTranslation } from 'react-i18next';

const HomeHeader = ({ displayName, organizations, currentOrg, onSwitchOrg, isOrgAdmin, projectsCount, tasksInProgress, tasksDueSoon }) => {
  const { t } = useTranslation();

  const summaries = [];
  if (projectsCount > 0) summaries.push(`${projectsCount} active project${projectsCount !== 1 ? 's' : ''}`);
  if (tasksInProgress > 0) summaries.push(`${tasksInProgress} task${tasksInProgress !== 1 ? 's' : ''} in progress`);
  if (tasksDueSoon > 0) summaries.push(`${tasksDueSoon} due this week`);

  return (
    <header className="admin-header">
      <div className="admin-header-top">
        <div>
          <h2>{t('home.welcome_greeting')}{displayName ? `, ${displayName}` : ''}</h2>
          <p className="admin-subtitle">
            {summaries.length > 0
              ? summaries.join(' · ')
              : t('home.welcome_subtitle')}
          </p>
        </div>
        <div className="admin-header-badges">
          {organizations.length > 1 ? (
            <select
              className="home-org-select"
              value={currentOrg}
              onChange={e => onSwitchOrg(e.target.value)}
            >
              {organizations.map(org => (
                <option key={org} value={org}>{org}</option>
              ))}
            </select>
          ) : currentOrg ? (
            <span className="version-badge">{currentOrg}</span>
          ) : null}
          {isOrgAdmin && (
            <span className="health-badge healthy">
              <span className="health-dot" />
              ADMIN
            </span>
          )}
        </div>
      </div>
    </header>
  );
};

export default HomeHeader;
